import { Helpers } from '../../helpers';
import { IScenarioType } from '../../interfaces/iscenario-type';
import { Scenario } from '../scenario';

export class ScenarioTypeBase {
  ScenarioTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenarios_ScenarioType?: Array<Scenario> | null;

  constructor(item?: IScenarioType) {
    if (item) {

      this.ScenarioTypeId = item.ScenarioTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenarios_ScenarioType = Helpers.createClassArray(Scenario, item.Scenarios_ScenarioType);
    }
  }
}